import gql from 'graphql-tag';
import { Collection } from '../types';
import { appsPageSize, numNextPages, numPrevPages } from '../sharedConfig';
import { pagedApps } from './fragments';

export type GetCollectionResponse = {
  collection: Collection;
};

export const getCategory = gql`
  query category($id: ID!, $pageKey: ID, $clientIpAddress: String) {
    collection: category(id: $id, clientIpAddress: $clientIpAddress) {
      id
      name
      pagedApps(pageOptions: {
        pageKey: $pageKey,
        limit: ${appsPageSize},
        numNextPages: ${numNextPages},
        numPrevPages: ${numPrevPages}
      }) {
        ...pagedApps
      }
      appType
    }
  }
  ${pagedApps}
`;
